import React from "react";
import { Col, Row, Container, Alert, Form, OverlayTrigger, Tooltip } from "react-bootstrap";
import { NavObjectType } from "../fileToolbarConsts";
import { activityCenterObject } from "./activityCenterTypes";
import { useAppSelector } from "../../redux/hooks";
import { lddStateObject, setPreference } from "../../redux/reducer";
import { useDispatch } from "react-redux";

interface IActivityCenterProps {
    page: NavObjectType,
    sidebarshow: string,
    toggleState: boolean,
}

interface IActivityCenterComponentProps {
    props: activityCenterObject,
    index: number,
}

enum ScreenType {
    InFile = "purfileedit",
    FirmSettings = "EditUserProfile",
}

export const ActivityCenter: React.FC<IActivityCenterProps> = (props: IActivityCenterProps) => {
    let drawerClasses = ''
    if (props.sidebarshow === 'Activity' && props.toggleState === true) {
        drawerClasses = ' open'
    }
    const activityCenterObjectArray: activityCenterObject[] = useAppSelector((g: lddStateObject) => g.ActivityCenter);
    const pinnedTab = useAppSelector((g: lddStateObject) => g.Preference["PinRightSideTab"]);
    const screenType = props.page.params? props.page.params['formasp'] : null;
    const dispatch = useDispatch();
    const pinClickHandler = () => {
        if (pinnedTab === "Activity") {
            // unpin
            dispatch(setPreference("PinRightSideTab", "toggle"));
        } else {
            // pin
            dispatch(setPreference("PinRightSideTab", "Activity"));
        }
    };
    const MAXIMUM_MESSAGES_SIZE = 30;

    return (
        <div className={"toolbar-content " + drawerClasses} key={'activity-center'}>
            <div className="toolbar-header">
                <h2>
                    Activity Centre
                    {screenType === ScreenType.InFile && (
                        <OverlayTrigger placement="bottom" delay={200} overlay={
                            <Tooltip>{pinnedTab === "Activity" ? `Unset default` : `Set as default`}</Tooltip>
                        }>
                            <i className={`${pinnedTab === "Activity" ? "fa-solid" : "fa-regular"} fa-thumbtack`}
                                onClick={pinClickHandler} />
                        </OverlayTrigger>
                    )}
                </h2>
            </div>

            <div className="toolbar-body">
                {activityCenterObjectArray.length === 0 &&
                    <Form.Label>No session activity.</Form.Label>
                }
                {activityCenterObjectArray.slice(0, MAXIMUM_MESSAGES_SIZE).map((props: activityCenterObject, index: number) => ActivityCenterComponent({ props, index }))}
            </div>
        </div>
    )
}

const ActivityCenterComponent: React.FC<IActivityCenterComponentProps> = ({ props, index }) => {
    const onClickOpenDocument = (props) => {
        let d = props.browserLink;
        if (d && d.openDocument)
            d.openDocument();
        else if (d && d.url)
            window.open(d.url, '_blank');
    }

    let alertVariant;
    switch (props.type) {
        case "success":
            alertVariant = "success";
            break;
        case "error":
            alertVariant = "warning";
            break;
        default:
            alertVariant = "primary";
            break;
    }

    let msgType;
    switch (props.type) {
        case "notification":
            msgType = "Notifications";
            break;
        case "word":
        case "pdf":
            if (props.browserLink != null) {
                if (props.browserLink.useMyDrive)
                    msgType = "MyDrive";
                else
                    msgType = "Downloads";
            } else
                msgType = "SpecificNetwork";
            break;
        case "onlineword":
            if (props.browserLink?.useMyCloud)
                msgType = "MyCloud";
            else
                msgType = "Downloads";
            break;
        default:
            msgType = "System";
            break;
    }

    if (props.type === "pdf" || props.type === "word" || props.type === "onlineword") {
        const matchResult = (props.message as string).match(/(?:.*\[(.*?)\]\s)?(?:.*:\s)?(.*)/);
        var documentName = matchResult ? matchResult[2] : "";
    }
    const timeCreated = props.dateCreated.match(/\d{1,2}:\d{2} [ap]m/) ? props.dateCreated.match(/\d{1,2}:\d{2} [ap]m/)[0] : props.dateCreated;

    return (
        <Alert key={`activityMessage-${index}`} variant={alertVariant}>
            <Container key={`activityMessage-${index}-container`} className="gx-0">
                <OverlayTrigger
                    placement="bottom" delay={200}
                    overlay={(msgType === "MyDrive") ? <Tooltip>Click to open document</Tooltip> : (msgType === "Downloads") ? <Tooltip>Click to download document</Tooltip> : <></>}
                >
                    <Row className={"g-2 " + ((msgType === "MyDrive" || msgType === "Downloads") ? "ldd_pointer" : "")}
                        onClick={() => { if (msgType === "MyDrive" || msgType === "Downloads") onClickOpenDocument(props) }}
                    >
                        <Col className="col-1">
                            {(props.type === "load" || props.type === "loading") &&
                                <i className="fa-duotone fa-spinner fa-spin" ></i>
                            }
                            {props.type === "error" &&
                                <i className="fa-solid fa-diamond-exclamation status-warning"></i>
                            }
                            {props.type === "success" &&
                                <i className="fa-solid fa-circle-check status-success"></i>
                            }
                            {props.type === "save" &&
                                <i className="fa-solid fa-floppy-disk"></i>
                            }
                            {props.type === "notification" &&
                                <i className="fa-solid fa-bell"></i>
                            }
                            {props.type === "pdf" &&
                                <i className="fa-solid fa-file-pdf"></i>
                            }
                            {(props.type === "word" || props.type === "onlineword") &&
                                <i className="fa-solid fa-file-word"></i>
                            }
                        </Col>

                        <Col className="col-11">
                            <Row className="gx-1">
                                <Col style={{ textOverflow: 'ellipsis', whiteSpace: 'normal', overflow: 'hidden' }}>
                                    {(props.type === "pdf" || props.type === "word" || props.type === "onlineword") ? (
                                        <b>{documentName}</b>
                                    ) : props.type === "load" ? (
                                        <>
                                            <b>Document Generating..</b>
                                            <div>{props.message}</div>
                                        </>
                                    ) : (
                                        <b>{props.message}</b>
                                    )}
                                </Col>

                                {msgType === "Downloads" &&
                                    <Col className="align-right" md="auto">
                                        <i className="fa-solid fa-download"></i>
                                    </Col>
                                }

                                {msgType === "MyDrive" &&
                                    <Col className="align-right" md="auto">
                                        <i className="fa-solid fa-arrow-up-right-from-square"></i>
                                    </Col>
                                }

                                {msgType === "MyCloud" &&
                                    <Col className="align-right" md="auto">
                                        <OverlayTrigger placement="bottom" delay={200} key={"desktop"} overlay={<Tooltip>Click to open document in desktop</Tooltip>}>
                                            <i style={{marginRight:'5px'}} onClick={() => {
                                                let d = props.browserLink;
                                                d.openDocument(false, true);
                                            }} className="fa-solid fa-desktop"></i>
                                        </OverlayTrigger>
                                        <OverlayTrigger placement="bottom" delay={200} key={"browser"} overlay={<Tooltip>Click to open document in browser</Tooltip>}>
                                            <i onClick={() => {onClickOpenDocument(props)}} className="fa-solid fa-arrow-up-right-from-square"></i>
                                        </OverlayTrigger>
                                    </Col>
                                }
                            </Row>

                            <Row className="gx-1">
                                <Col md="auto">
                                    <small>{timeCreated}</small>
                                </Col>
                                {props.fileNumber &&
                                    <Col style={{ textOverflow: 'ellipsis', whiteSpace: 'nowrap', overflow: 'hidden' }}>
                                        <small>-&nbsp;{props.fileNumber}</small>
                                    </Col>
                                }
                            </Row>
                        </Col>
                    </Row>
                </OverlayTrigger>
            </Container>
        </Alert>
    );
}